import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React, { CSSProperties } from "react";

export function HelpIcon(props: SvgIconProps) {
  const st0: CSSProperties = {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
  };

  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <circle style={st0} cx="6" cy="6" r="5.5" />
      <g>
        <path
          d="M5.33,7.02C5.31,6.95,5.28,6.85,5.26,6.73S5.23,6.5,5.23,6.39c0-0.18,0.04-0.34,0.11-0.49C5.41,5.76,5.5,5.62,5.61,5.49
			c0.11-0.13,0.22-0.25,0.35-0.36C6.08,5.01,6.2,4.9,6.3,4.79c0.11-0.11,0.2-0.23,0.27-0.35c0.07-0.12,0.11-0.26,0.11-0.4
			c0-0.13-0.03-0.25-0.08-0.35c-0.05-0.1-0.12-0.18-0.22-0.25c-0.09-0.07-0.2-0.11-0.32-0.15C5.95,3.26,5.82,3.24,5.69,3.24
			c-0.44,0-0.85,0.19-1.25,0.58V2.81c0.48-0.28,0.98-0.42,1.49-0.42c0.24,0,0.46,0.03,0.67,0.09S7,2.64,7.16,2.76
			S7.44,3.03,7.53,3.2s0.14,0.39,0.14,0.62c0,0.23-0.04,0.43-0.11,0.6S7.38,4.77,7.27,4.92C7.15,5.06,7.03,5.2,6.89,5.31
			C6.76,5.42,6.63,5.54,6.52,5.65C6.4,5.77,6.31,5.89,6.23,6.01S6.12,6.27,6.12,6.42c0,0.13,0.02,0.24,0.05,0.34s0.06,0.19,0.1,0.26
			H5.33z M5.83,8.88c-0.17,0-0.31-0.06-0.44-0.17C5.27,8.6,5.21,8.46,5.21,8.29c0-0.17,0.06-0.3,0.18-0.41
			c0.13-0.12,0.27-0.18,0.44-0.18c0.17,0,0.31,0.06,0.44,0.18C6.4,7.99,6.46,8.13,6.46,8.29c0,0.16-0.06,0.3-0.18,0.41
			C6.15,8.82,6,8.88,5.83,8.88z"
        />
      </g>
    </SvgIcon>
  );
}
